// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
} from 'firebase/functions';

const addPostAuthor = async ({
    test,
    postId,
    authorId,
}: {
    test: boolean,
    postId: string,
    authorId: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleAddPostAuthor = httpsCallable<
        Record<string, boolean | string>,
        boolean
    >(
        functions,
        'addPostAuthor',
    );
    return handleAddPostAuthor({
        test,
        postId,
        authorId,
    }).then((result) => result.data as boolean);
};

export default addPostAuthor;
